export { default } from "ember-router-helpers/helpers/root-url.js";
